import * as React from 'react';
import ScreenSetsContainer from './ScreenSetsContainer';
import styled from "styled-components";
import {Panel, PanelProps} from "../Panel";
import {BREAKPOINTS} from "../styles";


export const AuthPageWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;

  .panel {
    flex: 1;
    display: none;
  }

  ${BREAKPOINTS.MEDIUM} {
    .panel {
      display: flex;
    }
  }

  &.reverse {
    flex-direction: row-reverse;
  }
`;

export type AuthPageProps = {
  panel?: PanelProps;
  order?: 'default' | 'reverse';
  screenSetsContainerId: string;
};

const AuthPage = ({
                    screenSetsContainerId,
                    panel,
                    order = 'default'
                  }: AuthPageProps) => {
  return (
    <AuthPageWrapper className={order}>
      {
        panel && <Panel {...panel} order={order} className={`panel ${panel.className || ''}`}/>
      }
      <ScreenSetsContainer id={screenSetsContainerId} $centerContents={!panel}/>
    </AuthPageWrapper>
  );
};

export default AuthPage;
